export const SOCIAL_MEDIA_LINKS = {
  DISCORD: 'https://discord.com/invite/yBxhcBwNyg',
  TWITTER: 'https://twitter.com/arpeggi_labs',
  INSTAGRAM: 'https://www.instagram.com/arpeggi_labs',
  MIRROR: 'https://mirror.xyz/arpeggi.eth'
}

export const PUBLIC_NOTION_URL = 'https://docs.arpeggi.io/faq'
